import { api } from "../api.js";
import { shell, pageHeading, statusPanel, matchCard, hydrateCommitteeIdentity, championshipHeading } from "../components.js";
import {
  committeeFromStandings,
  escapeHtml,
  errorMessage,
  nonRedundantSubtitle,
  selectedCommittee,
  setSelectedCommittee,
} from "../utils.js";

export async function calendarView(params, signal) {
  let committee = selectedCommittee();
  const { group } = params;
  document.title = "Calendario | FIPAV Online";
  const renderShell = () => {
    document.querySelector("#app").innerHTML = shell(
      pageHeading("Calendario", "", committee ? `/comitati/${committee}/campionati` : "/") +
      `<div id="calendar-content">${statusPanel("Caricamento calendario…")}</div>`, { committee },
    );
  };
  renderShell();
  try {
    const standingsPayload = await api.standings(group, signal);
    const inferredCommittee = committeeFromStandings(standingsPayload);
    if (inferredCommittee && inferredCommittee !== committee) {
      committee = inferredCommittee;
      setSelectedCommittee(committee);
      renderShell();
    }
    if (!committee) throw new Error("Non è stato possibile identificare il comitato di questo girone.");
    hydrateCommitteeIdentity(api, committee, signal);
    const payload = await api.calendar(committee, group, signal);
    const calendar = payload.data || {};
    const subtitle = nonRedundantSubtitle(calendar.title, calendar["sub-title"]);
    const matches = Array.isArray(calendar.matches) ? calendar.matches : [];
    const grouped = matches.reduce((result, match) => {
      const key = match.day || "Calendario";
      (result[key] ||= []).push(match);
      return result;
    }, {});
    const markup = Object.entries(grouped).map(([day, items]) => `<section class="calendar-day">
      <div class="section-title"><h2>${escapeHtml(day)}</h2></div>
      <div class="match-list">${items.map((match) => matchCard(match, calendar.title, { showDay: false })).join("")}</div>
    </section>`).join("");
    document.querySelector("#calendar-content").innerHTML = `
      <section class="container championship-block championship-layout">${championshipHeading(group, calendar.title || "Calendario", subtitle, "calendar")}
      <div class="calendar-days">${markup || '<div class="status-panel empty" role="status">Calendario non disponibile.</div>'}</div></section>`;
  } catch (error) {
    if (error.name !== "AbortError") document.querySelector("#calendar-content").innerHTML = statusPanel(errorMessage(error), "error");
  }
}
